import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import ProfileDropdown from '../components/ProfileDropdown';

import profilePic from '../assets/images/users/img-avatar-not-photo.jpeg';
import logoSm from '../assets/images/logo-zoetis.png';

import { useSelector } from 'react-redux';
import { RootState } from '../redux/store';

export interface NotificationItem {
  id: number;
  text: string;
  subText: string;
  icon?: string;
  avatar?: string;
  bgColor?: string;
}

const ProfileMenus = [
  {
    label: 'Meus dados',
    icon: 'fe-user',
    redirectTo: '/meus-dados',
  },
  {
    label: 'Sair',
    icon: 'fe-log-out',
    redirectTo: '/auth/logout',
  },
];

interface TopbarProps {
  hideLogo?: boolean;
  navCssClasses?: string;
  openLeftMenuCallBack?: () => void;
  topbarDark?: boolean;
}

const Topbar = ({ hideLogo, navCssClasses, openLeftMenuCallBack, topbarDark }: TopbarProps) => {

  const [isopen, setIsopen] = useState<boolean>(false);

  const { user } = useSelector((state: RootState) => ({
    user: state.Auth.user
  }));

  const navbarCssClasses: string = navCssClasses || '';
  const containerCssClasses: string = !hideLogo ? 'container-fluid' : '';

  const handleLeftMenuCallBack = () => {
    setIsopen(!isopen);
    if (openLeftMenuCallBack) openLeftMenuCallBack();
  };

  return (
    <React.Fragment>
      <div className={`navbar-custom ${navbarCssClasses}`}>
        <div className={containerCssClasses}>
          {!hideLogo && (
            <div className="logo-box">
              <Link to="/" className="logo logo-dark text-center">
                <span className="logo-sm">
                  <img src={logoSm} alt="" height="122" />
                </span>
                <span className="logo-lg">

                </span>
              </Link>
              <Link to="/" className="logo logo-light text-center">
                <span className="logo-sm">
                  <img src={logoSm} alt="" height="22" />
                </span>
                <span className="logo-lg">

                </span>
              </Link>
            </div>
          )}

          <ul className="list-unstyled topnav-menu float-end mb-0">
            <li className="dropdown notification-list topbar-dropdown">
              <ProfileDropdown
                profilePic={profilePic}
                menuItems={ProfileMenus}
                username={user.firstName}
                userTitle={'Founder'}
              />
            </li>

          </ul>
          <ul className="list-unstyled topnav-menu topnav-menu-left m-0">
            <li>
              <button className="button-menu-mobile open-left d-lg-none d-bolck waves-effect waves-light" onClick={handleLeftMenuCallBack}>
                <i className="fe-menu" />
              </button>
            </li>
            <li>
              <Link
                to="#"
                className={classNames('navbar-toggle nav-link', {
                  open: isopen,
                })}
                onClick={handleLeftMenuCallBack}
              >
                <div className="lines">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Topbar;
